$(document).ready(function() {

    if ($('.how-it-works').length) {
        $('.how-it-works .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                autoHeight: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 30,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    how_it_works();

});

$(window).scroll(function() {
    how_it_works();
});

function how_it_works() {
    if ($('.how-it-works').length) {
        $('.how-it-works').each(function() {
            let el = $(this);
            let scrolled = scrolledVH(el);
            let heightCSS = window.getComputedStyle(el.find('.container-wrapper')[0]).height; 
            let value;

            let viewportHeight = window.innerHeight;

            let heightPX = parseFloat(heightCSS);
            let containerVH = (heightPX / viewportHeight) * 100;

            let maxScrollVH = containerVH - 25;

            if (scrolled <= 25) {
                value = 1;
            } else if (scrolled >= maxScrollVH) {
                value = Math.floor((maxScrollVH - 25) / 50) + 2;
            } else {
                value = Math.floor((scrolled - 25) / 50) + 2;
            }

            let $steps = el.find('.steps .step');

            $steps.removeClass('active');
            $steps.each(function(index) {
                if (index < value) {
                    $(this).addClass('active');
                }
            });

            let $datas = el.find('.datas .data');

            $datas.removeClass('active past');
            $datas.each(function(index) {
                if (index + 1 < value) {
                    $(this).addClass('past');
                } else if (index + 1 === value) {
                    $(this).addClass('active');
                }
            });

            let gap = window.getComputedStyle(el.find('.steps')[0]).gap;
            gap = parseFloat(gap);
            
            let number = el.find('.steps .step .number').outerHeight();
            let result = (number * value) + (gap * (value - 1));

            el.find('.line-1').css('height', `${result}px`);

        });
    }
}